/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown> }} Pagination_PageInputs */

const cs_pagination_page = /** @type {(inputs: Pagination_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stránka ${i?.page}`)
};

const en_pagination_page = /** @type {(inputs: Pagination_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.page}`)
};

/**
* | output |
* | --- |
* | "Page {page}" |
*
* @param {Pagination_PageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pagination_page = /** @type {((inputs: Pagination_PageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pagination_PageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pagination_page(inputs)
	return cs_pagination_page(inputs)
});